export default "__VITE_ASSET__CazcIRP4__"